import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './TechlinkItemOffers_style'
import { Typography, Grid } from '@material-ui/core'

const TechlinkItemOffers = (props) => {
    const { type, offerCount, totalCount, selectedLocationTag } = props
    const classes = useStyles()

    const constructSubTitle = () => {
        return `${getPageSubTitle()}.${getPluralizationSubTitle()}`
    }

    const getPageSubTitle = () => {
        if (!selectedLocationTag) {
            return `item_offers.${type}${totalCount ? '.with_total_count' : ''}.page_sub_title`
        } else {
            switch (selectedLocationTag.type) {
            case 'location':
                return `item_offers.${type}.page_sub_title_location`
            case 'studyDomain':
                return `item_offers.${type}.page_sub_title_study_domain`
            case 'quickFilter':
                return `item_offers.title.${type}.quick_filter.${selectedLocationTag.value}`
            default:
                return `item_offers.${type}${totalCount ? '.with_total_count' : ''}.page_sub_title`
            }
        }
    }

    const getFilterName = () => {
        if (!selectedLocationTag) return ''

        if (selectedLocationTag.type === 'location') {
            return selectedLocationTag.name
        } else {
            return selectedLocationTag.name.toLowerCase()
        }
    }

    const getPluralizationSubTitle = () => {
        return offerCount === 0 ? 'zero' : offerCount === 1 ? 'one' : 'other'
    }

    return (
        <Grid container className={classes.itemOffersMainContainer}>
            <Grid item xs={12} sm={6} className={classes.itemOffersTextBox}>
                <FormattedMessage id={constructSubTitle()} values={{ offer_count: offerCount, total_count: totalCount, filter: getFilterName() }} >
                    {text =>
                        <Typography variant='h1' className={classes.pageSubTitle} dangerouslySetInnerHTML={{ __html: text }} />
                    }
                </FormattedMessage>
            </Grid>
        </Grid>
    )
}

export default TechlinkItemOffers
